import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons';

export default function SocialFollow() {
  return (
    <div className="social-container">
      <a
        href="https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Fwww.history.com%2Fgeorge-washington-battle-map-american-revolution%2F"
        target="_blank"
        className="facebook social"
      >
        <FontAwesomeIcon icon={faFacebookF} size="2x" />
      </a>

      <a
        href="https://twitter.com/intent/tweet?url=http%3A%2F%2Fwww.history.com%2Fgeorge-washington-battle-map-american-revolution%2F&text=Check%20out%20this%20cool%20interactive%20battle%20map%20of%20George%20Washington%E2%80%99s%20key%20military%20battles%20at&via=history"
        target="_blank"
        className="twitter social"
      >
        <FontAwesomeIcon icon={faTwitter} size="2x" />
      </a>
    </div>
  );
}
